import { mfestsApi } from "api/mfests_api";

export const getFestival = async ({ authToken, slug }) => {
  const data = await mfestsApi.get({ authToken, url: `festival/${slug}` });
  return data.data[0];
};

export const putFestivalAttended = async ({ attended, authToken, slug }) => {
  const data = await mfestsApi.put({
    authToken,
    body: { attended },
    url: `festival/${slug}/attended`,
  });
  return data.data[0];
};

export const putFestivalWatchlist = async ({ add, authToken, slug }) => {
  const data = await mfestsApi.put({
    authToken,
    body: { add },
    url: `festival/${slug}/watchlist`,
  });
  return data.data[0];
};
